module.exports = __webpack_public_path__ + "img/uz.bbc26213.png";